var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBulk = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 23.41 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M23.41 7 19 2.59l-13 13V20h4.41Zm-2.82 0L11 16.59 9.41 15 19 5.41ZM8 18v-1.59L9.59 18Z",
  className: "cls-1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M17 17h-2v5H2V2h13v2h2V0H0v24h17z",
  className: "cls-1"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M4 4h8v2H4zM4 8h5v2H4zM4 12h2v2H4z",
  className: "cls-1"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBulk);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bulk.9b0ae17a9f5c5df3dc757f040221bd17.svg";